<div class="buttonActions">
  @if (chart) {
    <button
      class="p-menu-bar-button"
      pButton
      showDelay="250"
      tooltipPosition="top"
      type="button"
      icon="{{ lastLegendDisplayState ? 'far fa-eye' : 'far fa-eye-slash' }}"
      [life]="3000"
      pTooltip="{{ 'chartWidgetUi.showLegend' | translate }}"
      (click)="changeLegendView()"></button>
  }
  @if (this.widget.windowId) {
    <button
      class="p-menu-bar-button"
      icon="icon-search-bolder"
      pButton
      showDelay="250"
      tooltipPosition="top"
      type="button"
      [life]="3000"
      pTooltip="{{ 'widgetUi.openWindow' | translate }}"
      (click)="openTab($event)"></button>
  }
</div>

@if (dataToDisplay) {
  <p-chart #chart [data]="dataToDisplay" [height]="'100%'" [options]="options" [plugins]="plugins" [type]="chartType" />
} @else {
  <div class="no-data">
    <p class="no-data-label">{{ 'widget.noData' | translate }}</p>
  </div>
}
